<ul class="list-disc space-y-4 px-4 leading-relaxed">
  <li>
    We'll email <b>{{ guestName() }}</b> to confirm or reject the alteration request.
  </li>

  @if (datesChanged()) {
    <li
      >New stay: <strong>{{ alterationRequest().start_date | date: 'MMM d, yyyy' }}</strong> to
      <strong>{{ alterationRequest().end_date | date: 'MMM d, yyyy' }}</strong
      >.
    </li>
  }

  @if (adultsChanged() || childrenChanged() || infantsChanged() || petsChanged()) {
    <li
      >Guests: <strong>{{ alterationRequest().number_of_adults }}</strong> adults,
      <strong>{{ alterationRequest().number_of_children }}</strong> children,
      <strong>{{ alterationRequest().number_of_infants }}</strong> infants,
      <strong>{{ alterationRequest().number_of_pets }}</strong> pets
    </li>
  }

  <!-- Charging for the alteration -->
  @if (alterationDetails().financial_actions?.charge_splits?.total?.amount !== '0') {
    <li
      >If the guest accepts the alteration, they will be charged
      <strong>{{ alterationDetails().financial_actions?.charge_splits?.total?.formatted_string }}</strong
      >.</li
    >
  }

  @if (alterationRequest().refund_amount) {
    <li
      >If the guest accepts the alteration, they will receive a refund of
      <strong>{{ alterationRequest().refund_amount }}</strong
      >.</li
    >
  } @else if (alterationDetails().financial_actions?.refund_splits?.total?.amount !== '0') {
    <li
      >If the guest accepts the alteration, they will receive a refund of
      <strong>{{ alterationDetails().financial_actions?.refund_splits?.total?.formatted_string }}</strong
      >.</li
    >
  }

  <li
    >They will have <strong>{{ alterationRequest().expires_in }}</strong> to confirm or reject the alteration request.
  </li>

  <li>If they don't confirm in time, the dates will open up and the original reservation stays as-is.</li>
</ul>
